import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AppError, User, UserLayersGroup, UserRegionConfig } from '@core/api';

import { AppComplete } from '../models/app.models';

export const userActions = createActionGroup({
  source: 'User',
  events: {
    Login: props<{ email: string; password: string }>(),
    LoginWithCode: props<{ code: string }>(),
    Logout: emptyProps(),
    InitSSO: props<{ email: string }>(),
    SetSSOError: props<{ error: AppError; email?: string }>(),
    FetchUserLayersGroups: emptyProps(),
  },
});

export const userApiActions = createActionGroup({
  source: 'User/API',
  events: {
    'Login Success': props<AppComplete>(),
    'Login Fail': props<{ error: AppError; email?: string }>(),
    'Logout Success': emptyProps(),
    'Logout Fail': props<{ error: AppError }>(),
    'Token Expired': emptyProps(),
    'Token Deleted': emptyProps(),
    'Fetch User Success': props<{ user: User }>(),
    'Fetch User Fail': props<{ error: AppError }>(),
    'Fetch User Layers Groups Success': props<{ userLayersGroups: UserLayersGroup[] }>(),
    'Fetch User Layers Groups Fail': props<{ error: AppError }>(),
    'Update User Success': props<{ user: Partial<User> }>(),
    'Update User Fail': props<{ error: AppError }>(),
    'Update Region Config': props<{ regionConfig: Omit<UserRegionConfig, 'defaultChanged'> }>(),
    'Init SSO Success': props<{ redirectUrl: string }>(),
    'Init SSO Fail': props<{ error: AppError }>(),
  },
});
